module.exports = __webpack_public_path__ + "c5ef3ad021151b2abeb48bc22b9a3843.pdf";